import React, { useMemo } from 'react';
import OrderApi from '../OrderApi';
import OrderSettings from '../OrderSettings';
import DropMenu from '@dex/bubl-dash/src/lib/components/DropMenu/DropMenu';
import Link from '@dex/bubl-dash/src/lib/components/Link/Link';

const OrderActions: React.FC<any> = (props: any) => {

    const { data } = props;

    const del = OrderApi.delete(data.id, {
        onComplete: (response) => {

            if (data.modelName && data.id) {
                const event = new CustomEvent(data.modelName + data.id, { detail: 'deleted' });
                window.dispatchEvent(event);
            }

        }
    });

    return useMemo(() => {

        return (

            <DropMenu>

                <Link
                    path={`${OrderSettings.path}/${data.id}/view`}
                >
                    View
                </Link>

                {/* <Link
                    path={`${ OrderSettings.path }/${data.id}/edit`}
                >
                    Edit
                </Link> */}

                <Link
                    confirm={{
                        title: `Delete ${data[OrderSettings.primaryKey]}`,
                        message: "Are your sure you want to perform this action?"
                    }}
                    onClick={del.run}
                >
                    Delete
                </Link>

            </DropMenu>

        )

    }, [data, del]);

}

export default OrderActions;
